import { render, staticRenderFns } from "./PriceingHomeTwo.vue?vue&type=template&id=ec125674&"
import script from "./PriceingHomeTwo.vue?vue&type=script&lang=js&"
export * from "./PriceingHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports